import { Site } from '@envato/foundation-types'
import * as React from 'react'

import { getCurrentSiteDomain } from '../../../../common/utils/sites'
import { IItem } from '../../../../typings/searchResults'
import { ISeoItem } from '../../../../typings/seoMetadata'
import Button from '../../../components/button'
import ItemPreviewer from '../../../components/itemPreviewer'
import ItemThumbnailCarousel from '../itemThumbnailCarousel'
import PageSection from '../pageSection'
import SectionDescription from '../sectionDescription'

import * as styles from './featuredItemsSection.module.css'

const FeaturedItemsSection = ({
  name,
  items,
  metadata,
  videoMuted,
  muteVideo,
  reportItemClick,
  currentSite
}: {
  name: string
  items: IItem[]
  metadata: ISeoItem
  videoMuted: boolean
  muteVideo: () => any
  reportItemClick: (index: number, item: IItem, listName: string) => any
  currentSite: Site
}) => {
  return (
    <div
      id="featured-items-section"
      className={styles.section}
      data-test-selector="featuredItemSection"
    >
      <PageSection>
        <SectionDescription metadata={metadata} HTag="h3" />
        <ItemThumbnailCarousel justifyContent={'center'}>
          {items.map((item, index) => {
            return (
              <ItemPreviewer
                item={item}
                key={item.id}
                videoMuted={videoMuted}
                muteVideo={muteVideo}
                onClick={() => reportItemClick(index, item, name)}
              />
            )
          })}
        </ItemThumbnailCarousel>
        <div
          className={styles.buttonSection}
          data-test-selector="featuredItemButtonSection"
        >
          <Button
            type={Button.Type.Primary}
            href={`//${getCurrentSiteDomain(currentSite)}/feature`}
          >
            View More Featured Items
          </Button>
        </div>
      </PageSection>
    </div>
  )
}

export default FeaturedItemsSection
